import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';

@Injectable()

export class PrioritySubmissionEndpoint extends EndpointFactory {
  private readonly getOrganizationsEndpointPath: string = "/api/prioritySubmissionService/getOrganizations";
  private readonly getRtrApplicablesEndpointPath: string = "/api/prioritySubmissionService/getRtrApplicables";
  private readonly getDepartmentsEndpointPath: string = "/api/regulatoryItemService/getDepartments";
  private readonly getPrioritySubmissionItemTypesEndpointPath: string = "/api/prioritySubmissionService/getPrioritySubmissionItemTypes";
  private readonly getIndustryPanelsEndpointPath: string = "/api/prioritySubmissionService/getIndustryPanels";
  private readonly getSubmissionStatusEndpointPath: string = "/api/prioritySubmissionService/getSubmissionStatus";
  private readonly getPrioritySubmissionThemesEndpointPath: string = "/api/prioritySubmissionService/getPrioritySubmissionThemes";
  private readonly getAllPrioritySubmissionsEndpointPath: string = "/api/prioritySubmissionService/getAllPrioritySubmissions";
  private readonly getPrioritySubmissionsByDepartmentEndpointPath: string = "/api/prioritySubmissionService/getPrioritySubmissionsByDepartment";
  private readonly getPrioritySubmissionEndpointPath: string = "/api/prioritySubmissionService/getPrioritySubmission";
  private readonly getCrossCuttingThemesEndpointPath: string = "/api/prioritySubmissionService/getCrossCuttingThemes";

  private readonly submitPrioritySubmissionEndpointPath: string = "/api/prioritySubmissionService/submitPrioritySubmission";
  private readonly createPrioritySubmissionEndpointPath: string = "/api/prioritySubmissionService/createPrioritySubmission";
  private readonly fileUploadEndpointPath: string = "/api/prioritySubmissionService/uploadWebDocument";
  private readonly helpFileUploadEndpointPath: string = "/api/prioritySubmissionService/helpFileUpload";
  private readonly fileDownloadEndpointPath: string = "/api/prioritySubmissionService/downloadFile";
  private readonly helpFileDownloadEndpointPath: string = "/api/prioritySubmissionService/getFileUploadByName";
  private readonly importLegislationRegulatoryItemsEndpointPath: string = "/api/prioritySubmissionService/importLegislationRegulatoryItems";
  private readonly importAgencyRegulatoryItemsEndpointPath: string = "/api/prioritySubmissionService/importAgencyRegulatoryItems";

  get getCrossCuttingThemesEndpointUrl() { return this.configurations.baseUrl + this.getCrossCuttingThemesEndpointPath; }

  get getOrganizationsEndpointUrl() { return this.configurations.baseUrl + this.getOrganizationsEndpointPath; }
  get getRtrApplicablesEndpointUrl() { return this.configurations.baseUrl + this.getRtrApplicablesEndpointPath; }
  get getDepartmentsEndpointUrl() { return this.configurations.baseUrl + this.getDepartmentsEndpointPath; }
  get getPrioritySubmissionItemTypesEndpointUrl() { return this.configurations.baseUrl + this.getPrioritySubmissionItemTypesEndpointPath; }
  get getIndustryPanelsEndpointUrl() { return this.configurations.baseUrl + this.getIndustryPanelsEndpointPath; }
  get getSubmissionStatusEndpointUrl() { return this.configurations.baseUrl + this.getSubmissionStatusEndpointPath; }
  get getPrioritySubmissionThemesEndpointUrl() { return this.configurations.baseUrl + this.getPrioritySubmissionThemesEndpointPath; }
  get getAllPrioritySubmissionsEndpointUrl() { return this.configurations.baseUrl + this.getAllPrioritySubmissionsEndpointPath; }
  get getPrioritySubmissionsByDepartmentEndpointUrl() { return this.configurations.baseUrl + this.getPrioritySubmissionsByDepartmentEndpointPath; }
  get getPrioritySubmissionEndpointUrl() { return this.configurations.baseUrl + this.getPrioritySubmissionEndpointPath; }
  get submitPrioritySubmissionEndpointUrl() { return this.configurations.baseUrl + this.submitPrioritySubmissionEndpointPath; }
  get createPrioritySubmissionEndpointUrl() { return this.configurations.baseUrl + this.createPrioritySubmissionEndpointPath; }
  get fileUploadEndpointUrl() { return this.configurations.baseUrl + this.fileUploadEndpointPath; }
  get helpFileUploadEndpointPathEndpointUrl() { return this.configurations.baseUrl + this.helpFileUploadEndpointPath; }
  get fileDownloadEndpointUrl() { return this.configurations.baseUrl + this.fileDownloadEndpointPath; }
  get helpFileDownloadEndpointUrl() { return this.configurations.baseUrl + this.helpFileDownloadEndpointPath; }
  get importLegislationRegulatoryItemsEndpointUrl() { return this.configurations.baseUrl + this.importLegislationRegulatoryItemsEndpointPath; }
  get importAgencyRegulatoryItemsEndpointUrl() { return this.configurations.baseUrl + this.importAgencyRegulatoryItemsEndpointPath; }

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }

  getOrganizations<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getOrganizationsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getRtrApplicables<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getRtrApplicablesEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getDepartments<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getDepartmentsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getPrioritySubmissionItemTypes<T>(): Observable<T> {
    let endpointUrl = `${this.getPrioritySubmissionItemTypesEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  getIndustryPanels<T>(): Observable<T> {
    let endpointUrl = `${this.getIndustryPanelsEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  getSubmissionStatus<T>(): Observable<T> {
    let endpointUrl = `${this.getSubmissionStatusEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  getCrossCuttingThemes<T>(): Observable<T> {
    let endpointUrl = `${this.getCrossCuttingThemesEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  getPrioritySubmissionThemes<T>(): Observable<T> {
    let endpointUrl = `${this.getPrioritySubmissionThemesEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  getPrioritySubmission<T>(prioritySubmissionID?: string, userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getPrioritySubmissionEndpointUrl}/${prioritySubmissionID}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getAllPrioritySubmissions<T>(userProfileID?: string): Observable<T> {
    let endpointUrl = `${this.getAllPrioritySubmissionsEndpointUrl}/${userProfileID}`;
    return this.http.get<T>(endpointUrl);
  }

  getPrioritySubmissionsByDepartment<T>(departmentID?: string, annualPlanItemID?: string): Observable<T> {
    let endpointUrl = `${this.getPrioritySubmissionsByDepartmentEndpointUrl}/${departmentID}/${annualPlanItemID}`;
    return this.http.get<T>(endpointUrl);
  }


  createPrioritySubmission<T>(): Observable<T> {
    let endpointUrl = `${this.createPrioritySubmissionEndpointUrl}/`;
    return this.http.get<T>(endpointUrl);
  }

  submitPrioritySubmission<T>(userObject: any): Observable<T> {
    let endpointUrl = `${this.submitPrioritySubmissionEndpointUrl}/`;
    //console.log(this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders()));
    return this.http.post<T>(endpointUrl, JSON.stringify(userObject), this.getRequestHeaders());
  }
  
  async uploadExternalDocument(formData: any) {
    let endpointUrl = `${this.fileUploadEndpointUrl}/`;
    return await this.http.post(endpointUrl, formData, { reportProgress: true, observe: 'events' }).toPromise();
  }

  downloadFile(externalDocumentID: string, fileName: string): Observable<Blob> {
    let endpointUrl = `${this.fileDownloadEndpointUrl}/${externalDocumentID}/${fileName}`;
    return this.http.get(endpointUrl, { responseType: "blob" });
  }
  
}
